import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'light' | 'dark';
}

export function Logo({ className, size = 'md', variant = 'dark' }: LogoProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-10 w-10',
  };

  const iconSizes = {
    sm: 14,
    md: 18,
    lg: 22,
  };

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-md',
        variant === 'dark' ? 'bg-foreground' : 'bg-primary',
        sizeClasses[size],
        className
      )}
    >
      <svg
        width={iconSizes[size]}
        height={iconSizes[size]}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={variant === 'dark' ? 'text-background' : 'text-primary-foreground'}
      >
      {/* Wheels with center dots */}
      <circle cx="7" cy="16" r="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="7" cy="16" r="0.75" fill="currentColor" />
      <circle cx="17" cy="16" r="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="17" cy="16" r="0.75" fill="currentColor" />
      {/* Body with integrated wheel wells */}
      <path
        d="M3 12.5 L5.5 8 H18.5 L21 12.5 V16 H19 C19 14.9 18.1 14 17 14 C15.9 14 15 14.9 15 16 H9 C9 14.9 8.1 14 7 14 C5.9 14 5 14.9 5 16 H3 V12.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Top marker */}
      <circle cx="12" cy="5" r="1.5" fill="currentColor" />
      <path d="M12 6.5V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Face details (headlights with solid connector) */}
      <circle cx="8" cy="11" r="1" fill="currentColor" />
      <circle cx="16" cy="11" r="1" fill="currentColor" />
      <path d="M8 11H16" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
      </svg>
    </div>
  );
}
